import { Getter } from './Getter';
import { HttpError } from './HttpError';
import { Api } from 'utils/Api';

interface ApiResult<T> {
  status: number | null;
  data: T | null;
  success: boolean;
}

export class ApiGetter<T> implements Getter<T | null | HttpError> {
  public async get(href: string): Promise<T | null | HttpError> {
    const { status, success, data }: ApiResult<T> = await Api.get(href);

    if (success) {
      return data;
    }

    // status should never really be null in this situation,
    // but because of the typing in utils/Api, it could be.
    // Therefore, to please TS, we set error to 400
    return new HttpError(status ?? 400);
  }
}
